import LinkCardOrBankModal from '../UI/modals/dashboard/link_card_bank';
import NotificationsModal from '../UI/modals/settings/notifications';
import VerificationPhoneModal from '../UI/modals/settings/verification_phone';
import ChangePasswordModal from '../UI/modals/settings/change_password';
import SuccessActivateCardModal from '../UI/modals/xeppt_card/success_activate_card';
import CardDetailsEnterPasswordModal from '../UI/modals/xeppt_card/card_details/enter_password';
import CardDetailsModal from '../UI/modals/xeppt_card/card_details';
import LockCardModal from '../UI/modals/xeppt_card/lock_card';
import UnlockCardModal from '../UI/modals/xeppt_card/unlock_card';
import SuccessUpdatePinModal from '../UI/modals/xeppt_card/update_pin';
import UpdatePinModal from '../UI/modals/xeppt_card/update_pin/enter_pin';
import CardLimitsModal from '../UI/modals/xeppt_card/card_limits';
import ReplaceCardReasonModal from '../UI/modals/xeppt_card/replace_card/reason';
import ReplaceCardSubmitModal from '../UI/modals/xeppt_card/replace_card/submit';
import ReplaceCardSuccessModal from '../UI/modals/xeppt_card/replace_card';
import CancelCardReasonModal from '../UI/modals/xeppt_card/cancel_card/reason';
import VerifyCardActivationModal from '../UI/modals/xeppt_card/verify_card_activation';
import CancelCardSubmitModal from '../UI/modals/xeppt_card/cancel_card/submit';
import CancelCardSuccessModal from '../UI/modals/xeppt_card/cancel_card';
import ManageCardModal from '../UI/modals/xeppt_card/manage_card';
import VerificationEmailModal from '../UI/modals/settings/verification_email';
import AddPhoneModal from '../UI/modals/settings/add_phone';
import AddEmailModal from '../UI/modals/settings/add_email';
import DeleteEmailModal from '../UI/modals/settings/delete_email';
import LoadCardBalanceModal from '../UI/modals/xeppt_card/load_card_balance';
import LinkInteracModal from '../UI/modals/dashboard/link_interac';
import VerificationPhoneWalletModal from '../UI/modals/settings/verification_phone_wallet';
import VerificationPhoneUserModal from '../UI/modals/settings/verification_phone_profile';
import UploadAvatarModal from '../UI/modals/settings/upload_avatar';
import UserActivityModal from '../UI/modals/global/user_activity';
import CancelGiftCardModal from '../UI/modals/gift_cards/cancel_gift_card';
import { IModalComponentProps } from '@context/modal_context';
import KycModal from '../UI/modals/global/kyc';
import WaitVerificationModal from '../UI/modals/global/wait_verification';
import DeleteContactModal from '../UI/modals/e_transfer/delete_contact';
import SuccessAutodepositModal from '../UI/modals/e_transfer/success_autodeposit';
import DeletePayeeModal from '../UI/modals/pay_bills/delete_payee';
import DeletePaymentModal from '../UI/modals/pay_bills/delete_payment';
import PausePaymentModal from '../UI/modals/pay_bills/pause_payment';
import ResumePaymentModal from '../UI/modals/pay_bills/resume_payment';
import UpdateInteracModal from '../UI/modals/e_transfer/update_interac';
import DeleteAccountModal from '../UI/modals/manage_accounts/delete_account';
import SetPreferredAccountModal from '../UI/modals/manage_accounts/set_prefered';
import CashbackModal from '../UI/modals/global/cashback';
import ContactPaymentModal from '../UI/modals/send_and_request/contact_payment';
import DeleteWalletContactModal from '../UI/modals/send_and_request/delete_contact';
import SubmitRequestModal from '../UI/modals/help_center/submit_request';
import SetPreferredCardModal from '../UI/modals/manage_accounts/set_prefered_card';
import DeleteCardModal from '../UI/modals/manage_accounts/delete_card';
import DeletePhoneModal from '../UI/modals/settings/delete_phone';
import PreviewChatModal from '../UI/modals/global/preview_chat';
import CardAgreementModal from '../UI/modals/xeppt_card/card_agreement';
import ViewTransactionModal from '../UI/modals/global/view_transaction';
import ViewCardTransactionModal from '../UI/modals/global/view_card_transaction';
import ViewScheduleModal from '../UI/modals/global/view_schedule';
import HelloKycModal from '../UI/modals/global/kyc/hello_kyc';
import EstimatedFeeModal from '../UI/modals/send_and_request/estimated_fee';
import CancelScheduleModal from '../UI/modals/send_and_request/cancel_schedule';
import CancelBillScheduleModal from '../UI/modals/pay_bills/cancel_schedule';
import MarkResolved from '../UI/modals/help_center/mark_resolved';
import SuspendedModal from '../UI/modals/global/suspended';
import EnableMFA from '../UI/modals/settings/enable_mfa';
import DisableMFA from '../UI/modals/settings/disable_mfa';
import SuccessSubmitRequest from '../UI/modals/help_center/success_submit_request';
import ViewExtenralTransactionModal from '../UI/modals/global/view_external_transaction';
import FreezeCardModal from '../UI/modals/xeppt_card/freeze_card';
import UnfreezeCardModal from '../UI/modals/xeppt_card/unfreeze_card';
import AddEmailGiftCardModal from '../UI/modals/gift_cards/add_email_gift_card';
import RedeemGiftCardModal from '../UI/modals/gift_cards/redeem_gift_card';
import ViewGiftCardModal from '../UI/modals/gift_cards/view_gift_card';
import ActivateGiftCardModal from '../UI/modals/gift_cards/activate_gift_card';
import ScanGiftCardModal from '../UI/modals/gift_cards/scan_card';
import AddGiftCardDescription from '../UI/modals/gift_cards/add_description';
import CreateApiKeyModal from '../UI/modals/settings/api_keys/create/info';
import CreateApiKeyWarnModal from '../UI/modals/settings/api_keys/create/warn';
import CreateApiKeyConfigModal from '../UI/modals/settings/api_keys/create/config';
import DeleteApiKeysModal from '../UI/modals/settings/api_keys/delete';
import ViewOrderModal from '../UI/modals/global/view_order';

type ModalType = {
    modalId: string;
    confirmLabel?: string;
    cancelLabel?: string;
    isHeader?: boolean;
    ignoreOverlay?: boolean;
    submitVariant?: 'red' | 'primary';
    isFooter?: boolean;
    variant: 'medium' | 'small' | 'custom' | 'large' | 'drawer';
    Component: React.FC<IModalComponentProps> | null;
};

const modalIds = {
    LINK_BANK_OR_CARD: 'LINK_BANK_OR_CARD',
    SETTINGS_NOTIFICATION: 'SETTINGS_NOTIFICATION',
    SETTINGS_VERIFICATION_PHONE: 'SETTINGS_VERIFICATION_PHONE',
    CARD_AGREEMENT_MODAL: 'CARD_AGREEMENT_MODAL',
    DELETE_WALLET_CONTACT_MODAL: 'DELETE_WALLET_CONTACT_MODAL',
    PIN_VERIFICATION_PHONE: 'PIN_VERIFICATION_PHONE',
    PREFERRED_CARD: 'PREFERRED_CARD',
    USER_VERIFICATION_PHONE: 'USER_VERIFICATION_PHONE',
    SETTINGS_VERIFICATION_EMAIL: 'SETTINGS_VERIFICATION_EMAIL',
    SETTINGS_ADD_PHONE_MODAL: 'SETTINGS_ADD_PHONE_MODAL',
    SETTINGS_ADD_EMAIL_MODAL: 'SETTINGS_ADD_EMAIL_MODAL',
    CASHBACK_MODAL: 'CASHBACK_MODAL',
    SETTINGS_CHANGE_PASSWORD: 'SETTINGS_CHANGE_PASSWORD',
    SETTINGS_UPLOAD_IMAGE: 'SETTINGS_UPLOAD_IMAGE',
    SUCCESS_ACTIVATE_CARD: 'SUCCESS_ACTIVATE_CARD',
    CARD_DETAILS_ENTER_PASSWORD: 'CARD_DETAILS_ENTER_PASSWORD',
    CARD_DETAILS: 'CARD_DETAILS',
    LOCK_CARD: 'LOCK_CARD',
    UNLOCK_CARD: 'UNLOCK_CARD',
    UPDATE_PIN: 'UPDATE_PIN',
    SUCCESS_UPDATE_PIN: 'SUCCESS_UPDATE_PIN',
    CARD_LIMITS: 'CARD_LIMITS',
    REPLACE_CARD_REASON: 'REPLACE_CARD_REASON',
    REPLACE_CARD_SUBMIT: 'REPLACE_CARD_SUBMIT',
    REPLACE_CARD_SUCCESS: 'REPLACE_CARD_SUCCESS',
    CANCEL_CARD_REASON: 'CANCEL_CARD_REASON',
    CANCEL_CARD_SUBMIT: 'CANCEL_CARD_SUBMIT',
    CANCEL_CARD_SUCCESS: 'CANCEL_CARD_SUCCESS',
    MANAGE_CREDIT_CARD: 'MANAGE_CREDIT_CARD',
    DELETE_EMAIL: 'DELETE_EMAIL',
    LOAD_CARD_BALANCE: 'LOAD_CARD_BALANCE',
    LINK_INTERAC_EMAIL: 'LINK_INTERAC_EMAIL',
    USER_ACTIVITY_MODAL: 'USER_ACTIVITY_MODAL',
    CONTACT_PAYMENT_MODAL: 'CONTACT_PAYMENT_MODAL',
    KYC_FIRST_MODAL: 'KYC_FIRST_MODAL',
    VERIFICATION_PENDING: 'VERIFICATION_PENDING',
    DELETE_PHONE: 'DELETE_PHONE',
    DELETE_CONTACT: 'DELETE_CONTACT',
    SUCCESS_AUTODEPOSIT: 'SUCCESS_AUTODEPOSIT',
    DELETE_PAYEE: 'DELETE_PAYEE',
    DELETE_PAYMENT: 'DELETE_PAYMENT',
    PAUSE_PAYMENT: 'PAUSE_PAYMENT',
    VIEW_SCHEDULE: 'VIEW_SCHEDULE',
    RESUME_PAYMENT: 'RESUME_PAYMENT',
    UPDATE_INTERAC: 'UPDATE_INTERAC',
    DELETE_BANK_ACCOUNT: 'DELETE_BANK_ACCOUNT',
    DELETE_EPS_CARD: 'DELETE_EPS_CARD',
    PREFERRED_ACCOUNT: 'PREFERRED_ACCOUNT',
    SUBMIT_HELP_REQUEST: 'SUBMIT_HELP_REQUEST',
    VIEW_TRANSACTION: 'VIEW_TRANSACTION',
    HELLO_KYC_MODAL: 'HELLO_KYC_MODAL',
    ESTIMATED_FEES: 'ESTIMATED_FEES',
    CANCEL_SCHEDULE: 'CANCEL_SCHEDULE',
    CANCEL_BILL_SCHEDULE: 'CANCEL_BILL_SCHEDULE',
    MARK_TICKET_SOLVED: 'MARK_TICKET_SOLVED',
    PREVIEW_ATTACHMENT: 'PREVIEW_ATTACHMENT',
    ENABLE_MFA: 'ENABLE_MFA',
    DISABLE_MFA: 'DISABLE_MFA',
    VERIFY_CARD_ACTIVATION: 'VERIFY_CARD_ACTIVATION',
    SUCCESS_SUBMIT_REQUEST: 'SUCCESS_SUBMIT_REQUEST',
    SUSPENDED_USER: 'SUSPENDED_USER',
    VIEW_EXTERNAL_TRANSACTION: 'VIEW_EXTERNAL_TRANSACTION',
    FREEZE_CARD: 'FREEZE_CARD',
    UNFREEZE_CARD: 'UNFREEZE_CARD',
    EMAIL_GIFT_CARD: 'EMAIL_GIFT_CARD',
    REDEEM_GIFT_CARD: 'REDEEM_GIFT_CARD',
    VIEW_GIFT_CARD: 'VIEW_GIFT_CARD',
    ACTIVATE_GIFT_CARD_MODAL: 'ACTIVATE_GIFT_CARD_MODAL',
    SCAN_GIFT_CARD_QR: 'SCAN_GIFT_CARD_QR',
    ADD_GIFT_CARD_DESCRIPTION: 'ADD_GIFT_CARD_DESCRIPTION',
    CANCEL_GIFT_CARD: 'CANCEL_GIFT_CARD',
    VIEW_CARD_TRANSACTION: 'VIEW_CARD_TRANSACTION',
    CREATE_API_KEYS: 'CREATE_API_KEYS',
    DELETE_API_KEYS: 'DELETE_API_KEYS',
    VIEW_ORDER: 'VIEW_ORDER',
    API_KEY_INFO: 'API_KEY_INFO',
    CREATE_API_KEY_CONFIG: 'CREATE_API_KEY_CONFIG'
};

const linkBankOrCardModal: ModalType = {
    modalId: modalIds.LINK_BANK_OR_CARD,
    variant: 'small',
    Component: LinkCardOrBankModal
};

const settingsNotificationsModal: ModalType = {
    modalId: modalIds.SETTINGS_NOTIFICATION,
    confirmLabel: 'done',
    isHeader: true,
    isFooter: true,
    variant: 'small',
    Component: NotificationsModal
};

const settingsVerificationPhoneModal: ModalType = {
    modalId: modalIds.SETTINGS_VERIFICATION_PHONE,
    confirmLabel: 'verify',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: VerificationPhoneModal
};

const settingsVerificationEmailModal: ModalType = {
    modalId: modalIds.SETTINGS_VERIFICATION_EMAIL,
    confirmLabel: 'verify',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: VerificationEmailModal
};

const settingsAddPhoneModal: ModalType = {
    modalId: modalIds.SETTINGS_ADD_PHONE_MODAL,
    confirmLabel: 'verify',
    cancelLabel: 'cancel',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: AddPhoneModal
};

const settingsAddEmailModal: ModalType = {
    modalId: modalIds.SETTINGS_ADD_EMAIL_MODAL,
    confirmLabel: 'verify',
    cancelLabel: 'cancel',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: AddEmailModal
};

const settingsChangePasswordModal: ModalType = {
    modalId: modalIds.SETTINGS_CHANGE_PASSWORD,
    confirmLabel: 'save',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: ChangePasswordModal
};

const successActivateCardModal: ModalType = {
    modalId: modalIds.SUCCESS_ACTIVATE_CARD,
    confirmLabel: 'add_money_to_card',
    cancelLabel: 'do_this_later',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: SuccessActivateCardModal
};

const cardDetailsEnterPasswordModal: ModalType = {
    modalId: modalIds.CARD_DETAILS_ENTER_PASSWORD,
    confirmLabel: 'done',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: CardDetailsEnterPasswordModal
};

const walletPhoneVerification: ModalType = {
    modalId: modalIds.PIN_VERIFICATION_PHONE,
    confirmLabel: 'verify',
    cancelLabel: 'cancel',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: VerificationPhoneWalletModal
};
const userPhoneVerification: ModalType = {
    modalId: modalIds.USER_VERIFICATION_PHONE,
    confirmLabel: 'verify',
    cancelLabel: 'cancel',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: VerificationPhoneUserModal
};

const cardDetailsModal: ModalType = {
    modalId: modalIds.CARD_DETAILS,
    confirmLabel: 'done',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: CardDetailsModal
};

const lockCardModal: ModalType = {
    modalId: modalIds.LOCK_CARD,
    confirmLabel: 'done',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: LockCardModal
};

const unlockCardModal: ModalType = {
    modalId: modalIds.UNLOCK_CARD,
    confirmLabel: 'done',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: UnlockCardModal
};

const updatePinModal: ModalType = {
    modalId: modalIds.UPDATE_PIN,
    confirmLabel: 'update',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: UpdatePinModal
};

const successUpdatePinModal: ModalType = {
    modalId: modalIds.SUCCESS_UPDATE_PIN,
    confirmLabel: 'done',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: SuccessUpdatePinModal
};

const cardLimitsModal: ModalType = {
    modalId: modalIds.CARD_LIMITS,
    confirmLabel: 'done',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: CardLimitsModal
};

const replaceCardReasonModal: ModalType = {
    modalId: modalIds.REPLACE_CARD_REASON,
    confirmLabel: 'replace_card',
    submitVariant: 'red',
    cancelLabel: 'keep_it',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: ReplaceCardReasonModal
};

const replaceCardSubmitModal: ModalType = {
    modalId: modalIds.REPLACE_CARD_SUBMIT,
    confirmLabel: 'yes',
    cancelLabel: 'cancel',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: ReplaceCardSubmitModal
};

const replaceCardSuccessModal: ModalType = {
    modalId: modalIds.REPLACE_CARD_SUCCESS,
    confirmLabel: 'done',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: ReplaceCardSuccessModal
};

const cancelCardReasonModal: ModalType = {
    modalId: modalIds.CANCEL_CARD_REASON,
    confirmLabel: 'cancel_card',
    cancelLabel: 'keep_it',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    submitVariant: 'red',
    Component: CancelCardReasonModal
};

const cancelCardSubmitModal: ModalType = {
    modalId: modalIds.CANCEL_CARD_SUBMIT,
    confirmLabel: 'cancel_card',
    cancelLabel: 'cancel',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    submitVariant: 'red',
    Component: CancelCardSubmitModal
};

const manageCreditCardModal: ModalType = {
    modalId: modalIds.MANAGE_CREDIT_CARD,
    isHeader: true,
    variant: 'large',
    Component: ManageCardModal
};

const cancelCardSuccessModal: ModalType = {
    modalId: modalIds.CANCEL_CARD_SUCCESS,
    confirmLabel: 'keep_it',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    Component: CancelCardSuccessModal
};

const deleteEmail: ModalType = {
    modalId: modalIds.DELETE_EMAIL,
    confirmLabel: 'yes',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    submitVariant: 'red',
    Component: DeleteEmailModal
};

const deletePhone: ModalType = {
    modalId: modalIds.DELETE_PHONE,
    confirmLabel: 'yes',
    isHeader: true,
    isFooter: true,
    variant: 'medium',
    submitVariant: 'red',
    Component: DeletePhoneModal
};

const loadCardBalanceModal: ModalType = {
    modalId: modalIds.LOAD_CARD_BALANCE,
    confirmLabel: 'add_money',
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    Component: LoadCardBalanceModal
};

const linkInteracEmail: ModalType = {
    modalId: modalIds.LINK_INTERAC_EMAIL,
    confirmLabel: 'submit',
    isHeader: true,
    isFooter: true,
    variant: 'small',
    Component: LinkInteracModal
};

const uploadImageModal: ModalType = {
    modalId: modalIds.SETTINGS_UPLOAD_IMAGE,
    isHeader: true,
    variant: 'medium',
    Component: UploadAvatarModal
};

const userActivityModal: ModalType = {
    modalId: modalIds.USER_ACTIVITY_MODAL,
    variant: 'small',
    Component: UserActivityModal
};

const kycFirstModal: ModalType = {
    modalId: modalIds.KYC_FIRST_MODAL,
    isHeader: true,
    variant: 'custom',
    Component: KycModal
};

const verificationPendingModal: ModalType = {
    modalId: modalIds.VERIFICATION_PENDING,
    isHeader: true,
    variant: 'small',
    Component: WaitVerificationModal
};

const deleteContactModal: ModalType = {
    modalId: modalIds.DELETE_CONTACT,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'yes_delete',
    cancelLabel: 'cancel',
    submitVariant: 'red',
    Component: DeleteContactModal
};

const successAutodepositModal: ModalType = {
    modalId: modalIds.SUCCESS_AUTODEPOSIT,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'done',
    Component: SuccessAutodepositModal
};

const deletePayeeModal: ModalType = {
    modalId: modalIds.DELETE_PAYEE,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'yes_delete',
    cancelLabel: 'cancel',
    submitVariant: 'red',
    Component: DeletePayeeModal
};

const deletePaymentModal: ModalType = {
    modalId: modalIds.DELETE_PAYMENT,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'yes_delete',
    cancelLabel: 'cancel',
    submitVariant: 'red',
    Component: DeletePaymentModal
};

const pausePaymentModal: ModalType = {
    modalId: modalIds.PAUSE_PAYMENT,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'pause',
    cancelLabel: 'cancel',
    Component: PausePaymentModal
};

const resumePaymentModal: ModalType = {
    modalId: modalIds.RESUME_PAYMENT,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'resume',
    cancelLabel: 'cancel',
    Component: ResumePaymentModal
};

const updateInteracModal: ModalType = {
    modalId: modalIds.UPDATE_INTERAC,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'save',
    cancelLabel: 'cancel',
    Component: UpdateInteracModal
};

const deleteAccountModal: ModalType = {
    modalId: modalIds.DELETE_BANK_ACCOUNT,
    isHeader: true,
    variant: 'custom',
    isFooter: true,
    confirmLabel: 'remove',
    cancelLabel: 'cancel',
    submitVariant: 'red',
    Component: DeleteAccountModal
};

const deleteCardModal: ModalType = {
    modalId: modalIds.DELETE_EPS_CARD,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'remove',
    cancelLabel: 'cancel',
    submitVariant: 'red',
    Component: DeleteCardModal
};

const deleteWalletContactModal: ModalType = {
    modalId: modalIds.DELETE_WALLET_CONTACT_MODAL,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'yes_delete',
    cancelLabel: 'cancel',
    submitVariant: 'red',
    Component: DeleteWalletContactModal
};

const setPreferredAccountModal: ModalType = {
    modalId: modalIds.PREFERRED_ACCOUNT,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'confirm',
    cancelLabel: 'cancel',
    Component: SetPreferredAccountModal
};

const setPreferredCardModal: ModalType = {
    modalId: modalIds.PREFERRED_CARD,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'confirm',
    cancelLabel: 'cancel',
    Component: SetPreferredCardModal
};

const submitRequestModal: ModalType = {
    modalId: modalIds.SUBMIT_HELP_REQUEST,
    isHeader: true,
    variant: 'small',
    isFooter: true,
    confirmLabel: 'submit',
    cancelLabel: 'cancel',
    Component: SubmitRequestModal
};

const contactPaymentModal: ModalType = {
    modalId: modalIds.CONTACT_PAYMENT_MODAL,
    isHeader: true,
    variant: 'small',
    Component: ContactPaymentModal
};

const cashbackModal: ModalType = {
    modalId: modalIds.CASHBACK_MODAL,
    variant: 'medium',
    isHeader: true,
    Component: CashbackModal
};

const previewAttachmentModal: ModalType = {
    modalId: modalIds.PREVIEW_ATTACHMENT,
    variant: 'custom',
    isHeader: true,
    Component: PreviewChatModal
};

const cardAgreementModal: ModalType = {
    modalId: modalIds.CARD_AGREEMENT_MODAL,
    variant: 'custom',
    isHeader: true,
    Component: CardAgreementModal
};

const viewTransactionModal: ModalType = {
    modalId: modalIds.VIEW_TRANSACTION,
    variant: 'drawer',
    isHeader: false,
    isFooter: false,
    Component: ViewTransactionModal
};

const viewCardTransactionModal: ModalType = {
    modalId: modalIds.VIEW_CARD_TRANSACTION,
    variant: 'drawer',
    isHeader: false,
    isFooter: false,
    Component: ViewCardTransactionModal
};

const viewOrderModal: ModalType = {
    modalId: modalIds.VIEW_ORDER,
    variant: 'drawer',
    isHeader: false,
    isFooter: false,
    Component: ViewOrderModal
};

const viewScheduleModal: ModalType = {
    modalId: modalIds.VIEW_SCHEDULE,
    variant: 'drawer',
    isHeader: false,
    isFooter: false,
    Component: ViewScheduleModal
};

const helloKycModal: ModalType = {
    modalId: modalIds.HELLO_KYC_MODAL,
    variant: 'custom',
    isHeader: true,
    isFooter: false,
    Component: HelloKycModal
};

const estimatedFeesModal: ModalType = {
    modalId: modalIds.ESTIMATED_FEES,
    variant: 'custom',
    isHeader: true,
    isFooter: false,
    Component: EstimatedFeeModal
};

const cancelScheduleModal: ModalType = {
    modalId: modalIds.CANCEL_SCHEDULE,
    variant: 'custom',
    cancelLabel: 'no_keep_it',
    confirmLabel: 'yes_cancel_payment',
    submitVariant: 'red',
    isHeader: true,
    isFooter: true,
    Component: CancelScheduleModal
};

const cancelBillScheduleModal: ModalType = {
    modalId: modalIds.CANCEL_BILL_SCHEDULE,
    variant: 'custom',
    cancelLabel: 'no_keep_it',
    confirmLabel: 'yes_cancel_payment',
    submitVariant: 'red',
    isHeader: true,
    isFooter: true,
    Component: CancelBillScheduleModal
};

const markTicketAsSolved: ModalType = {
    modalId: modalIds.MARK_TICKET_SOLVED,
    variant: 'custom',
    cancelLabel: 'cancel',
    confirmLabel: 'yes_mark_solved',
    submitVariant: 'red',
    isHeader: true,
    isFooter: true,
    Component: MarkResolved
};

const suspendedModal: ModalType = {
    modalId: modalIds.SUSPENDED_USER,
    variant: 'custom',
    isHeader: true,
    isFooter: false,
    Component: SuspendedModal
};

const enableMFAModal: ModalType = {
    modalId: modalIds.ENABLE_MFA,
    variant: 'custom',
    isHeader: true,
    isFooter: true,
    confirmLabel: 'yes_enable_mfa',
    cancelLabel: 'cancel',
    Component: EnableMFA
};

const disableMFAModal: ModalType = {
    modalId: modalIds.DISABLE_MFA,
    variant: 'custom',
    isHeader: true,
    isFooter: true,
    confirmLabel: 'yes_disable_mfa',
    cancelLabel: 'cancel',
    submitVariant: 'red',
    Component: DisableMFA
};

const cardActivationModal: ModalType = {
    modalId: modalIds.VERIFY_CARD_ACTIVATION,
    confirmLabel: 'activate',
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    cancelLabel: 'cancel',
    Component: VerifyCardActivationModal
};

const freezeCardModal: ModalType = {
    modalId: modalIds.FREEZE_CARD,
    confirmLabel: 'freeze_card',
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    cancelLabel: 'cancel',
    Component: FreezeCardModal
};

const unfreezeCardModal: ModalType = {
    modalId: modalIds.UNFREEZE_CARD,
    confirmLabel: 'unfreeze_card',
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    cancelLabel: 'cancel',
    Component: UnfreezeCardModal
};

const successSubmitRequestModal: ModalType = {
    modalId: modalIds.SUCCESS_SUBMIT_REQUEST,
    confirmLabel: 'done',
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    Component: SuccessSubmitRequest
};

const viewExternalTransactionModal: ModalType = {
    modalId: modalIds.VIEW_EXTERNAL_TRANSACTION,
    isHeader: false,
    isFooter: false,
    variant: 'drawer',
    Component: ViewExtenralTransactionModal
};

const emailGiftCardModal: ModalType = {
    modalId: modalIds.EMAIL_GIFT_CARD,
    isHeader: true,
    isFooter: true,
    cancelLabel: 'cancel',
    variant: 'custom',
    Component: AddEmailGiftCardModal
};

const redeemGiftCardModal: ModalType = {
    modalId: modalIds.REDEEM_GIFT_CARD,
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    confirmLabel: 'redeem',
    cancelLabel: 'cancel',
    Component: RedeemGiftCardModal
};

const viewGiftCardModal: ModalType = {
    modalId: modalIds.VIEW_GIFT_CARD,
    isHeader: false,
    isFooter: false,
    variant: 'drawer',
    Component: ViewGiftCardModal
};

const activateGiftCardModal: ModalType = {
    modalId: modalIds.ACTIVATE_GIFT_CARD_MODAL,
    // Drawer (slides in from the right) like the gift-card details view. The component
    // renders its OWN header (title + close) AND its own sticky Cancel/Activate footer so
    // the bottom action bar matches the details drawer exactly — hence isHeader and
    // isFooter are both false. The Activate button calls the shared onSubmit prop.
    isHeader: false,
    isFooter: false,
    confirmLabel: 'activate',
    cancelLabel: 'cancel',
    variant: 'drawer',
    Component: ActivateGiftCardModal
};

const scanGiftCardQrModal: ModalType = {
    modalId: modalIds.SCAN_GIFT_CARD_QR,
    isHeader: true,
    isFooter: false,
    variant: 'custom',
    Component: ScanGiftCardModal
};

const addGiftCardDescription: ModalType = {
    modalId: modalIds.ADD_GIFT_CARD_DESCRIPTION,
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    confirmLabel: 'add',
    cancelLabel: 'cancel',
    Component: AddGiftCardDescription
};

const cancelGiftCardModal: ModalType = {
    modalId: modalIds.CANCEL_GIFT_CARD,
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    confirmLabel: 'yes_cancel',
    cancelLabel: 'no_keep_it',
    Component: CancelGiftCardModal
};

const createApiKeyInfoModal: ModalType = {
    modalId: modalIds.API_KEY_INFO,
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    confirmLabel: 'yes_create',
    cancelLabel: 'cancel',
    Component: CreateApiKeyWarnModal
};

const createApiKeyWarnModal: ModalType = {
    modalId: modalIds.CREATE_API_KEYS,
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    confirmLabel: 'done',
    Component: CreateApiKeyModal
};

const createApiKeyConfigModal: ModalType = {
    modalId: modalIds.CREATE_API_KEY_CONFIG,
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    confirmLabel: 'create_key',
    cancelLabel: 'cancel',
    Component: CreateApiKeyConfigModal
};

const deleteApiKeysModal: ModalType = {
    modalId: modalIds.DELETE_API_KEYS,
    isHeader: true,
    isFooter: true,
    variant: 'custom',
    confirmLabel: 'yes_delete',
    submitVariant: 'red',
    cancelLabel: 'cancel',
    Component: DeleteApiKeysModal
};

const modals: ModalType[] = [
    linkInteracEmail,
    loadCardBalanceModal,
    successSubmitRequestModal,
    cardAgreementModal,
    suspendedModal,
    linkBankOrCardModal,
    settingsNotificationsModal,
    settingsVerificationPhoneModal,
    settingsChangePasswordModal,
    successActivateCardModal,
    cardDetailsEnterPasswordModal,
    walletPhoneVerification,
    settingsVerificationEmailModal,
    cardDetailsModal,
    lockCardModal,
    unlockCardModal,
    updatePinModal,
    successUpdatePinModal,
    cardLimitsModal,
    replaceCardReasonModal,
    replaceCardSubmitModal,
    replaceCardSuccessModal,
    cancelCardReasonModal,
    cancelCardSuccessModal,
    manageCreditCardModal,
    settingsAddPhoneModal,
    settingsAddEmailModal,
    cardActivationModal,
    deleteEmail,
    cancelCardSubmitModal,
    deletePhone,
    userPhoneVerification,
    uploadImageModal,
    kycFirstModal,
    verificationPendingModal,
    userActivityModal,
    deleteContactModal,
    deletePayeeModal,
    deletePaymentModal,
    resumePaymentModal,
    pausePaymentModal,
    successAutodepositModal,
    updateInteracModal,
    deleteAccountModal,
    submitRequestModal,
    cashbackModal,
    setPreferredAccountModal,
    deleteCardModal,
    deleteWalletContactModal,
    setPreferredCardModal,
    previewAttachmentModal,
    viewTransactionModal,
    viewCardTransactionModal,
    viewScheduleModal,
    contactPaymentModal,
    cancelScheduleModal,
    markTicketAsSolved,
    cancelBillScheduleModal,
    estimatedFeesModal,
    enableMFAModal,
    disableMFAModal,
    viewExternalTransactionModal,
    freezeCardModal,
    unfreezeCardModal,
    helloKycModal,
    viewGiftCardModal,
    redeemGiftCardModal,
    emailGiftCardModal,
    scanGiftCardQrModal,
    addGiftCardDescription,
    activateGiftCardModal,
    cancelGiftCardModal,
    createApiKeyInfoModal,
    createApiKeyWarnModal,
    createApiKeyConfigModal,
    viewOrderModal,
    deleteApiKeysModal
];

export { modals, modalIds };
